import React from "react";
import {
  Button,
  Callout,
  Intent,
  Tag,
  FormGroup,
  InputGroup,
  Dialog,
  DialogBody,
  DialogFooter,
} from "@blueprintjs/core";
import { Trans } from "react-i18next";
import {
  authenticatedPostFetchWithResult,
  authenticatedDeleteFetch,
  authenticatedPutFetch,
} from "../../utils/AuthenticatedFetch";
import EventFiltersConfig from "../Supervision/Events/EventFiltersConfig";
import i18n from "../../i18n";

export class EventConfig {
  constructor() {
    this.id = undefined;
    this.name = "";
    this.eventsList = [];
  }
}

export default class EventFilteringEditor extends React.Component {
  constructor() {
    super();
    this.state = {
      openDialog: false,
      filterList: [],
      filterId: -1,
      newEvent: {
        name: "filter name",
        eventsList: [],
      },
    };
  }

  componentDidMount() {
    const data = localStorage.getItem("event_filtering");
    if (data) this.setState({ filterList: JSON.parse(data) });
    else this.setState({ filterList: [] });
  }

  async sendNewEvent(config) {
    return new Promise((res, rej) => {
      authenticatedPostFetchWithResult(
        "/eventFiltering",
        config,
        (rep, response) => {
          const list = this.state.filterList;
          list.push({
            id: response[0].id,
            name: response[0].data[0].name,
            eventsList: response[0].data[0].eventsList,
          });
          this.setState({ filterList: list });
          this.saveToLocalStorage(list);
          res(list);
        },
        (err) => {
          console.log("add eventFiltering failed");
          rej(err);
        }
      );
    });
  }

  async updateEvent(config) {
    return new Promise((res, rej) => {
      authenticatedPutFetch(
        "/eventFiltering",
        config,
        (response) => {
          const list = [...this.state.filterList];
          const index = list.findIndex((item) => item.id === config.id);
          if (index > -1) {
            list[index].name = config.name;
            list[index].eventsList = config.eventsList;
            this.setState({ filterList: list });
            this.saveToLocalStorage(list);
            res(list);
          } else rej();
        },
        (err) => {
          console.log("add eventFiltering failed");
          rej(err);
        }
      );
    });
  }
  async onDeleteFiltering(id) {
    return new Promise((res, rej) => {
      authenticatedDeleteFetch(
        "/eventFiltering",
        { id: id },
        (rep) => {
          const data = this.state.filterList;
          const index = data.findIndex((e) => e.id === id);
          if (index !== -1) {
            data.splice(index, 1);
            this.saveToLocalStorage(data);
            this.setState({ eventsList: data });
          }
          res();
        },
        (err) => {
          console.log("delete eventFiltering failed");
          rej(err);
        }
      );
    });
  }

  saveToLocalStorage(eventsList) {
    localStorage.setItem("event_filtering", JSON.stringify(eventsList));
  }

  async onSaveFiltering() {
    const config = new EventConfig();
    if (this.state.filterId === -1) {
      config.name = this.state.newEvent.name;
      config.eventsList = this.state.newEvent.eventsList;
      await this.sendNewEvent(config);
    } else {
      const index = this.state.filterList.findIndex(
        (item) => item.id === this.state.filterId
      );
      if (index > -1) {
        config.id = this.state.filterId;
        config.name = this.state.newEvent.name;
        config.eventsList = this.state.filterList[index].eventsList;
        await this.updateEvent(config);
      }
    }
    this.setState({ openDialog: false, filterId: -1 });
  }

  getFilteringListRendering() {
    const elem = [];
    this.state.filterList?.forEach((item, index) => {
      elem.push(
        <Callout key={"filire"+index} title={<><Trans>{item.name}</Trans> <Tag>{item.eventsList?.length} <Trans>events</Trans></Tag></>}>
          <Button
            icon="edit"
            intent={Intent.PRIMARY}
            style={{ margin: "1px 1px 1px 1px" }}
            onClick={() =>
              this.setState({
                openDialog: true,
                filterId: item.id,
                newEvent: { eventsList: item.eventsList, name: item.name },
              })
            }
          >
            <Trans>edit</Trans>
          </Button>
          <Button
            icon="trash"
            intent={Intent.DANGER}
            style={{ margin: "1px 1px 1px 1px" }}
            onClick={() => this.onDeleteFiltering(item.id)}
          >
            <Trans>remove</Trans>
          </Button>
        </Callout>
      );
    });

    return elem;
  }

  onUpdate = (eventsList) => {
    if (this.state.filterId === -1)
      this.setState({
        newEvent: { ...this.state.newEvent, eventsList: eventsList },
      });
    else {
      const data = [...this.state.filterList];
      const index = data.findIndex((item) => item.id === this.state.filterId);
      if (index > -1) {
        data[index].eventsList = eventsList;
        this.setState({
          filterList: data,
          newEvent: { ...this.state.newEvent, eventsList: eventsList },
        });
      }
    }
  };

  render() {
    const footerActions = (
      <div
        className="flexbox-center-large"
        style={{ justifyContent: "space-around" }}
      >
        <div>
          <FormGroup
            inline={true}
            label={<Trans>filter name</Trans>}
            labelFor="name_filter"
          >
            <InputGroup
              icon="edit"
              id="name_filter"
              value={this.state.newEvent.name}
              onChange={(filter) =>
                this.setState({
                  newEvent: {
                    ...this.state.newEvent,
                    name: filter.target.value,
                  },
                })
              }
            />
          </FormGroup>
        </div>
        <div>
          <Button
            icon="key-enter"
            onClick={() => this.setState({ openDialog: false, filterId: -1 })}
            text={i18n.t("return")}
          />
          <Button
            disabled={this.state.newEvent.name.length === 0}
            icon="upload"
            intent={Intent.PRIMARY}
            onClick={() => this.onSaveFiltering()}
          >
            <Trans>send</Trans>
          </Button>
        </div>
      </div>
    );

    return (
      <Callout title={<Trans>event filtering</Trans>} icon="filter-list">
        <Button
          icon="add"
          text={<Trans>Create an event filter</Trans>}
          onClick={() => {
            this.setState({
              openDialog: true,
              filterId: -1,
              newEvent: { name: "filter name", eventsList: [] },
            });
          }}
        />
        {this.getFilteringListRendering()}
        <Dialog
          style={{ transition: "none" }}
          canEscapeKeyClose={true}
          canOutsideClickClose={true}
          isOpen={this.state.openDialog}
          onClose={() => this.setState({ openDialog: false, filterId: -1 })}
          title={<Trans>Create an event filter</Trans>}
        >
          
          <DialogBody useOverflowScrollContainer="minimal">
            <EventFiltersConfig
              onUpdate={this.onUpdate}
              data={this.state.newEvent.eventsList}
              name={this.state.newEvent.name}
              filterId={this.state.filterId}
            />
          </DialogBody>
          <DialogFooter actions={footerActions}></DialogFooter>
        </Dialog>
      </Callout>
    );
  }
}
